import { defineStore } from 'pinia';

export const useDialogResponseStore = defineStore('DialogResponse', {
	state: () => ({
		isOpenDialog: false,
		message: '',
		content: {},
	}),

	actions: {
		showResponseModal() {
			this.isOpenDialog = true;
		},

		closeResponseModal() {
			this.isOpenDialog = false;
		},

		toggleResponseModal() {
			this.isOpenDialog = !this.isOpenDialog;
		},

		setResponseModalMessage(message: string) {
			this.message = message;
		},
	},
});
